import { catalog_default } from "./catalog-DaTB1cy-.js";
import { createSearchToolsTool } from "./search-tools-CbtWC7w4.js";
import { createExecuteTool } from "./execute-tool-B_06lhoJ.js";

//#region src/tools/index.ts
function getAllTools() {
	return allTools;
}
const allTools = {
	...catalog_default,
	search_sentry_tools: createSearchToolsTool(getAllTools),
	execute_sentry_tool: createExecuteTool(getAllTools)
};
var tools_default = allTools;

//#endregion
export { tools_default };
//# sourceMappingURL=tools-fGO-TOBm.js.map